import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.header}>
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.dates}>
        <div className={styles.group}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.date} />
        </div>
        <div className={styles.group}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.date} />
        </div>
      </div>
      <div className={styles.description}>
        <div className={styles.row}>
          <Skeleton className={styles.text} />
          <Skeleton className={styles.text} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.text} />
          <Skeleton className={styles.text} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.text} />
          <div className={styles.text} />
        </div>
      </div>
      <div className={styles.group}>
        <Skeleton className={styles.subTitle} />
        <div className={styles.tags}>
          <Skeleton className={styles.tag} />
          <Skeleton className={styles.tag} />
        </div>
      </div>
      <div className={styles.group}>
        <Skeleton className={styles.subTitle} />
        <div className={styles.tags}>
          <Skeleton className={styles.tag} />
        </div>
      </div>
    </div>
  );
}

export { Loader };
